const { setTimeout } = require("core-js");
const { markRaw } = require("vue");

var utils = {

    BASE_API:"",
    TOKEN:"",
    SESSION_TOKEN:"",
    TIMEOUT_SESSIONE:0,
    INIZIO_SESSIONE:0,
    API_TOKEN:"",
    deltaGriglia:0,
    RELOAD_SESSIONE_SCADUTA:0,
    appoggio:{},


    trimDeep: function(value) {
        if (typeof value == "string") {
            return value.trim();
        }
        if (Array.isArray(value)) {
            return value.map(global.utils.trimDeep);
        }
        if (value != null && typeof value == "object" && !(value instanceof File) && !(value instanceof Blob) && !(value instanceof Date)) {
            for (const key in value) {
                value[key] = global.utils.trimDeep(value[key]);
            }
            return value;
        }
        return value;
    },

    /* DASH-CUSTOM-04 B.FIX: i 4 helper restituiscono la Promise di ajax().
       Il valore restituito e' stato IGNORATO da tutti i 712 call-site legacy,
       quindi il comportamento osservabile e' identico a prima. Il valore e'
       esposto per i futuri caller OPT-IN che vogliono osservare il fallimento
       (Fase 4 / DASH-CUSTOM-04 Stage B). */
    get : function(_api,_args,_handler,_showBar,_flgGestioneEsito,_propagateRejection){
        return global.utils.ajax(_api,_args,_handler,_showBar,_flgGestioneEsito,"GET",_propagateRejection);
    },
    post : function(_api,_args,_handler,_showBar,_flgGestioneEsito,_propagateRejection){
        return global.utils.ajax(_api,_args,_handler,_showBar,_flgGestioneEsito,"POST",_propagateRejection);
    },
    put : function(_api,_args,_handler,_showBar,_flgGestioneEsito,_propagateRejection){
        return global.utils.ajax(_api,_args,_handler,_showBar,_flgGestioneEsito,"PUT",_propagateRejection);
    },
    delete : function(_api,_args,_handler,_showBar,_flgGestioneEsito,_propagateRejection){
        return global.utils.ajax(_api,_args,_handler,_showBar,_flgGestioneEsito,"DELETE",_propagateRejection);
    },

    /* Lock di modifica (SharedLock in dryland_2). handler(stato) riceve {MIO, USERNAME}
       all'acquisizione e a ogni heartbeat: se l'altro utente chiude, il lock passa a noi da solo. */
    lock : {
        aperti : [],
        INATTIVITA_MIN : 15,    // sovrascritto dal server (CORE_OPZIONI_SITO.LOCK_INATTIVITA_MIN) a ogni acquisisci
        ultimaAttivita : Date.now(),
        inAscolto : false,
        // ricarica: chiamata quando il lock passa da un altro a me, i dati a video potrebbero essere vecchi
        acquire : function(risorsa, id, handler, ricarica = null){
            var L = global.utils.lock;
            L.ascolta();
            // markRaw: salvato in data() resta lo stesso oggetto (niente Proxy), così i confronti == funzionano
            var handle = markRaw({ RISORSA: risorsa, ID_RISORSA: id, mio: null });
            handle.chiama = (forza) => global.utils.post('shared/lock/acquisisci', { RISORSA: risorsa, ID_RISORSA: id, FORZA: forza ? 1 : 0 }, (res) => {
                var s = res.data;
                if (s.INATTIVITA_MIN > 0) L.INATTIVITA_MIN = s.INATTIVITA_MIN;
                if (handle.mio == null && !s.MIO && s.PUO_FORZARE) global.utils.alert.confirm("In modifica da " + s.USERNAME + ". Vuoi prendere il controllo?", () => handle.chiama(true), global.root, "Conferma scelta", () => handler({ ...s, PUO_FORZARE: false }));
                else if (handle.mio == true && !s.MIO) global.utils.alert.warning(s.USERNAME + " ha preso la risorsa: le modifiche non salvate restano a video, copiale prima di chiudere");
                // CAMBIATO_DA: la credevo mia, ma mentre ero inattivo un altro l'ha presa e rilasciata
                if (handle.mio == true && s.CAMBIATO_DA) global.utils.alert.warning(s.CAMBIATO_DA + " ha usato questa scheda mentre eri via: dati ricaricati");
                var liberato = (handle.mio == false && s.MIO) || (handle.mio == true && s.CAMBIATO_DA);
                handle.mio = s.MIO;
                handler(s);
                if (liberato && ricarica) ricarica();
            }, false, 1);
            handle.chiama();
            // inattivo: non rinnova e il server libera dopo SCADENZA_MINUTI; al ritorno ascolta() lo riprende subito
            handle.timer = setInterval(() => { if (!L.inattivo()) handle.chiama(); }, 60000);
            L.aperti.push(handle);
            return handle;
        },
        inattivo : function(){
            return Date.now() - global.utils.lock.ultimaAttivita > global.utils.lock.INATTIVITA_MIN * 60000;
        },
        ascolta : function(){
            var L = global.utils.lock;
            if (L.inAscolto) return;
            L.inAscolto = true;
            var attivo = () => { var eraInattivo = L.inattivo(); L.ultimaAttivita = Date.now(); if (eraInattivo) L.aperti.forEach(h => h.chiama()); };
            ['mousemove', 'keydown', 'click'].forEach(e => document.addEventListener(e, attivo, { passive: true }));
        },
        release : function(handle){
            if (!handle) return;
            clearInterval(handle.timer);
            global.utils.lock.aperti = global.utils.lock.aperti.filter(h => h != handle);
            global.utils.post('shared/lock/rilascia', { RISORSA: handle.RISORSA, ID_RISORSA: handle.ID_RISORSA }, () => {}, false, 1);
        },
        // chiusura tab: keepalive fa arrivare la richiesta anche a pagina che si chiude (fallback: scadenza 2 min)
        releaseAll : function(){
            global.utils.lock.aperti.forEach(h => fetch(global.utils.BASE_API + 'shared/lock/rilascia', {
                method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ RISORSA: h.RISORSA, ID_RISORSA: h.ID_RISORSA, SESSION_TOKEN: global.utils.SESSION_TOKEN })
            }));
        }
    },

    /* B.FIX: _propagateRejection (default false) e' un canale OPT-IN.
       - false (default, identico a prima): il catch gestisce l'errore e la
         Promise si risolve: nessun unhandled rejection sui caller fire-and-forget.
       - true: il catch gestisce l'errore (alert + unblock invariati) e poi
         RILASCIA, cosi' il caller che ha passato true puo' osservare il fallimento.
       Il rethrow e' SEMPRE condizionato a questo parametro: applicarlo
       incondizionatamente produrrebbe unhandled rejection sui 712 caller legacy. */
    ajax : function(_api,_args,_handler,_showBar = true,_flgGestioneEsito = 0,_method = null,_propagateRejection = false){
        _method = (_method == undefined || _method == null) ? "POST" : _method;
        if (_showBar == true ){
            global.utils.blockPage();
        }
        _args.SESSION_TOKEN = global.utils.SESSION_TOKEN; //'tvnqs0iv0q8b8qft9n1dds9ra7'; //
        _args = global.utils.trimDeep(_args);
        var _url = global.utils.BASE_API + _api;
        var _fetchOptions = { method: _method, headers: {'Accept': 'application/json'} };
        if (_method == "GET"){
            _url += (_url.indexOf('?') > -1 ? '&' : '?') + new URLSearchParams(_args).toString();
        }
        else{
            _fetchOptions.body = JSON.stringify(_args);
            _fetchOptions.headers['Content-Type'] = 'application/json';
        }
        /* B.FIX: la catena viene restituita al chiamante. Il comportamento
           legacy e' invariato perche' tutti i 712 call-site ignorano il ritorno.
           _propagateRejection=true consente al caller OPT-IN di osservare il
           network failure con .catch(), senza generare unhandled rejection sui
           caller fire-and-forget (che non passano il parametro). */
        return fetch(_url, _fetchOptions)
        .then(response => {
            return response.json();
        })
        .then(data => {
            if (_showBar == true ){
                global.utils.unblockPage();
            }
            if (data.esito == 0){
                if (global.filters && global.filters.root && global.filters.root.resetSessionTimer) {
                    global.filters.root.resetSessionTimer();
                }
                if (data['arrayCampi'] != undefined && data['compressed'] != undefined){
                    data.data = global.utils.getArrayFromJSON(data.arrayCampi,data.data);
                }
                _handler(data);
            }
            else{
                //SESSIONE UTENTE SCADUTA
                if (data.esito == 401){                       
                    if (global.utils.RELOAD_SESSIONE_SCADUTA == 1){
                        //global.utils.alert.standard("Sessione utente scaduta");
                        global.sprint._component.methods.startHandler();
                    }
                    else{
                        global.sprint._component.methods.startHandler();
                    }
                }
                //FORCE LOGOUT
                else if(data.esito == 999){
                    global.utils.blockPage();
                    setTimeout(() => {
                        global.utils.alert.standard(data.messaggio);
                    }, 500);
                    setTimeout(() => {
                        window.location.href = global.utils.BASE_API + "core/logout";
                    }, 3000);
                }
                if (_flgGestioneEsito == undefined || _flgGestioneEsito == 0){
                    global.utils.alert.warning(data.messaggio);
                }
                else{
                    _handler(data);
                }
            }
        })
        .catch(err => {
            global.utils.alert.danger("Si è verificato un errore");
            if (_showBar == true ){
                global.utils.unblockPage();
            }
            /* B.FIX: comportamento storico (la Promise si risolve, nessun
               unhandled rejection) SALVO che il caller abbia chiesto
               esplicitamente l'osservabilita' del fallimento. */
            if (_propagateRejection == true){
                throw err;
            }
        });
    },

    ajaxText: function (_api, _args, _handler, _showBar = true, _method = 'GET') {
        if (_showBar) global.utils.blockPage();

        _args.SESSION_TOKEN = global.utils.SESSION_TOKEN;
        _args = global.utils.trimDeep(_args);

        const url = global.utils.BASE_API + _api;

        const fetchOptions = {
            method: _method,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        };

        // Serializza i parametri
        const urlParams = new URLSearchParams(_args).toString();

        if (_method.toUpperCase() === 'GET') {
            fetch(url + '?' + urlParams, fetchOptions)
                .then(response => response.text())
                .then(text => {
                    if (_showBar) global.utils.unblockPage();
                    _handler(text);
                })
                .catch(error => {
                    global.utils.alert.danger("Errore nel caricamento del file");
                    console.error(error);
                    if (_showBar) global.utils.unblockPage();
                });
        } else {
            fetchOptions.body = urlParams;

            fetch(url, fetchOptions)
                .then(response => response.text())
                .then(text => {
                    if (_showBar) global.utils.unblockPage();
                    _handler(text);
                })
                .catch(error => {
                    global.utils.alert.danger("Errore nel caricamento del file");
                    console.error(error);
                    if (_showBar) global.utils.unblockPage();
                });
        }
    },

    ajaxBlob: function (_api, _args, _handler, _showBar = true, _method = 'GET') {
        if (_showBar) global.utils.blockPage();

        _args.SESSION_TOKEN = global.utils.SESSION_TOKEN;
        _args = global.utils.trimDeep(_args);

        const url = global.utils.BASE_API + _api;
        const fetchOptions = {
            method: _method,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        };

        const urlParams = new URLSearchParams(_args).toString();

        const doFetch = (_url, _options) => {
            fetch(_url, _options)
                .then(response => {
                    if (!response.ok) throw new Error("Errore HTTP: " + response.status);
                    return response.blob(); // 👈 Riceviamo direttamente un blob
                })
                .then(blob => {
                    if (_showBar) global.utils.unblockPage();
                    _handler(blob); // 🔁 Passa il blob ricevuto
                })
                .catch(error => {
                    global.utils.alert.danger("❌ Errore durante il caricamento blob");
                    console.error(error);
                    if (_showBar) global.utils.unblockPage();
                });
        };

        if (_method.toUpperCase() === 'GET') {
            doFetch(`${url}?${urlParams}`, fetchOptions);
        } else {
            fetchOptions.body = urlParams;
            doFetch(url, fetchOptions);
        }
    },


    connect : function(address,root,protocollo,handler,flgAutenticazione = 0){
        utils.blockPage();
        root.connessioneSocket = 0;

        // Ottieni token JWT per autenticazione socket
        const token = global.utils.API_TOKEN;

        if (!token) {
            console.error('Cannot connect socket: no auth token available');
            utils.unblockPage();
            if (root.isGod) utils.alert.danger("Impossibile connettersi: token di autenticazione mancante","Errore","",5000);
            return;
        }

        root.appoggio.socket = io(address, {
            path: "/socket.io",
            //transports: ['websocket', 'polling', 'flashsocket'],
            transports: ['websocket'],
            timeout:3000,
            auth: {
                token: token
            }
        });
        root.appoggio.socket.on('connect', () => {
            root.connessioneSocket = 1;
            utils.unblockPage();
            if (root.isGod) utils.alert.success("Connessione socket stabilita","Attenzione","",5000);
            if (root.isGod) console.info("CONNESSIONE SOCKET AVVENUTA");
            handler();
        });
        root.appoggio.socket.on('connect_error', (err) => {
            utils.unblockPage();
            if (err.message.includes('Authentication')) {
                console.error('Socket authentication failed:', err.message);
                if (root.isGod) utils.alert.danger("Autenticazione socket fallita","Errore","",5000);
            } else {
                console.error('Socket connection error:', err.message);
                if (root.isGod) utils.alert.danger("Errore di connessione socket","Errore","",5000);
            }
        });
        root.appoggio.socket.on('disconnect', (args) => {
            root.connessioneSocket = 0;
            if (root.isGod) utils.alert.danger("Connessione socket persa","Attenzione","",5000);
            utils.unblockPage();
            console.info("DISCONNESSIONE SOCKET AVVENUTA");
            if (root.appoggio.hasOwnProperty('mascheraCorrente')){
                if (typeof root.appoggio.mascheraCorrente.disconnessioneSocket == 'function'){
                    root.appoggio.mascheraCorrente.disconnessioneSocket()
                }
            }
        });
        root.appoggio.socket.on('error', (args) => {
            utils.unblockPage();
            if (root.appoggio.hasOwnProperty('mascheraCorrente')){
                if (typeof root.appoggio.mascheraCorrente.disconnessioneSocket == 'function'){
                    root.appoggio.mascheraCorrente.disconnessioneSocket()
                }
            }
        });
    },    
    
    upload : function(_api,_args,_handler,_showBar = true,_flgGestioneEsito = 0,_method = null){
        _method = (_method == undefined || _method == null) ? "POST" : _method;
        if (_showBar == true ){
            global.utils.blockPage();
        }
        _api += "?SESSION_TOKEN="+global.utils.SESSION_TOKEN;
        utils.ajax({
			type: _method,
			data: _args,
			url: global.utils.BASE_API + _api,
			cache: false,
            processData: false,
            contentType: false,
            enctype: 'multipart/form-data',
			success: function (data) {
                if (_showBar == true ){
                    global.utils.unblockPage();
                }
                if (data.esito == 0){
                    if (data['arrayCampi'] != undefined && data['compressed'] != undefined){
                        data.data = global.utils.getArrayFromJSON(data.arrayCampi,data.data);
                    }
                    _handler(data);
                }
                else{
                    //SESSIONE UTENTE SCADUTA
                    if (data.esito == 401){
                        if (global.utils.RELOAD_SESSIONE_SCADUTA == 1){
                            //global.utils.alert.standard("Sessione utente scaduta");
                            global.sprint._component.methods.startHandler();
                        }
                        else{
                            global.sprint._component.methods.startHandler();
                        }
                    }
                    //FORCE LOGOUT
                    else if(data.esito == 999){
                        global.utils.blockPage();
                        setTimeout(() => {
                            global.utils.alert.standard(data.messaggio);
                        }, 500);
                        setTimeout(() => {
                            window.location.href = global.utils.BASE_API + "core/logout";
                        }, 3000);
                    }
                    if (_flgGestioneEsito == undefined || _flgGestioneEsito == 0){
                        global.utils.alert.warning(data.messaggio);
                    }
                    else{
                        _handler(data);
                    }
                }
            },
            error: function( jqXHR,  textStatus, errorThrown ){
                global.utils.alert.danger("Si è verificato un errore");
                console.error(jqXHR,textStatus,errorThrown);
                if (jqXHR.status == 0){
                   // global.utils.stopSocket();
                }
                if (_showBar == true ){
                    global.utils.unblockPage();
                }
            }
		});
    },

    uploadAjax: function(_api, _args, _handler, _showBar = true, _flgGestioneEsito = 0, _method = "POST") {
        if (_showBar) {
            global.utils.blockPage();
        }
        const url = global.utils.BASE_API + _api;
        // Verifico se _args è già un FormData, altrimenti lo creo
        let formData = _args instanceof FormData ? _args : new FormData();
        if (!(_args instanceof FormData)) {
            for (const key in _args) {
                formData.append(key, global.utils.trimDeep(_args[key]));
            }
        }
        // Aggiungo il SESSION_TOKEN
        formData.append("SESSION_TOKEN", global.utils.SESSION_TOKEN);
        fetch(url, {
            method: _method,
            body: formData, // FormData gestisce da solo il Content-Type multipart/form-data
        })
        .then(response => {
            /*if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();*/
            return response.text().then(text => {
        
                try {
                    // Proviamo a fare il parsing JSON
                    const jsonData = JSON.parse(text);
                    return jsonData;
                } catch (error) {
                    console.error("❌ La risposta non è un JSON valido!", error);
                    throw new Error("Il server ha restituito un formato non JSON: " + text);
                }
            });
            
        })
        .then(data => {
            if (_showBar) {
                global.utils.unblockPage();
            }
    
            if (data.esito === 0) {
                if (data['arrayCampi'] !== undefined && data['compressed'] !== undefined) {
                    data.data = global.utils.getArrayFromJSON(data.arrayCampi, data.data);
                }
                _handler(data);
            } else {
                if (data.esito === 401) {
                    if (global.utils.RELOAD_SESSIONE_SCADUTA === 1) {
                        global.sprint._component.methods.startHandler();
                    } else {
                        global.sprint._component.methods.startHandler();
                    }
                } else if (data.esito === 999) {
                    global.utils.blockPage();
                    setTimeout(() => {
                        global.utils.alert.standard(data.messaggio);
                    }, 500);
                    setTimeout(() => {
                        window.location.href = global.utils.BASE_API + "core/logout";
                    }, 3000);
                }
    
                /*if (_flgGestioneEsito === 0) {
                    global.utils.alert.warning(data.messaggio);
                }*/
    
                _handler(data);
            }
        })
        .catch(err => {
            if (_showBar) {
                global.utils.unblockPage();
            }
            global.utils.alert.danger("Si è verificato un errore di rete.");
            console.error("Errore di rete", err);
            _handler({ esito: -1, messaggio: "Errore di rete", error: err });
        });
    },


    /*
    uploadNew : function(_api,_args,_handler,_showBar = true,_flgGestioneEsito = 0,_method = null){
        _method = (_method == undefined || _method == null) ? "POST" : _method;
        if (_showBar == true ){
            global.utils.blockPage();
        }
        //console.log(_api);
        let formData;
        if(_args instanceof FormData){
            formData = _args
        }else{
            formData = new FormData();
            for (const key in _args){
                formData.append(key, _args[key])
            }
        }
        //console.log(formData)
        utils.ajax(_api, formData,function(data){

            if (_showBar == true ){
                global.utils.unblockPage();
            }    
            if (data.esito == 0){
                if (data['arrayCampi'] != undefined && data['compressed'] != undefined){
                    data.data = global.utils.getArrayFromJSON(data.arrayCampi,data.data);
                }
                _handler(data);
            }
            else{
                //SESSIONE UTENTE SCADUTA
                if (data.esito == 401){
                    if (global.utils.RELOAD_SESSIONE_SCADUTA == 1){
                        //global.utils.alert.standard("Sessione utente scaduta");
                        global.sprint._component.methods.startHandler();
                    }
                    else{
                        global.sprint._component.methods.startHandler();
                    }
                }
                //FORCE LOGOUT
                else if(data.esito == 999){
                    global.utils.blockPage();
                    setTimeout(() => {
                        global.utils.alert.standard(data.messaggio);
                    }, 500);
                    setTimeout(() => {
                        window.location.href = global.utils.BASE_API + "core/logout";
                    }, 3000);
                }
                if (_flgGestioneEsito == undefined || _flgGestioneEsito == 0){
                    global.utils.alert.warning(data.messaggio);
                }
                else{
                    _handler(data);
                }
            }
        }, _showBar, _flgGestioneEsito, _method);
    },
    
    uploadNew : function(_api,_args,_handler,_showBar = true,_flgGestioneEsito = 0,_method = null){
       
        if (_showBar == true ){
            global.utils.blockPage();
        }
        const url = global.utils.BASE_API +_api;
        let body = _args instanceof FormData ? _args : new FormData();
        if ( !(_args instanceof FormData)){
            for (const key in _args){
                body.append(key, _args[key])
            }
        }
        body.append("SESSION_TOKEN",global.utils.SESSION_TOKEN);

        fetch(url,{
            method: _method,
            body: body,
        })
        .then(response => response.json()) 
        .then(data => {
            if (_showBar == true ){
                global.utils.unblockPage();
            }
            if (data.esito == 0){
                if (data['arrayCampi'] != undefined && data['compressed'] != undefined){
                    data.data = global.utils.getArrayFromJSON(data.arrayCampi,data.data);
                }
                _handler(data);
            }
            else{
                //SESSIONE UTENTE SCADUTA
                if (data.esito == 401){                       
                    if (global.utils.RELOAD_SESSIONE_SCADUTA == 1){
                        //global.utils.alert.standard("Sessione utente scaduta");
                        global.sprint._component.methods.startHandler();
                    }
                    else{
                        global.sprint._component.methods.startHandler();
                    }
                }
                //FORCE LOGOUT
                else if(data.esito == 999){
                    global.utils.blockPage();
                    setTimeout(() => {
                        global.utils.alert.standard(data.messaggio);
                    }, 500);
                    setTimeout(() => {
                        window.location.href = global.utils.BASE_API + "core/logout";
                    }, 3000);
                }
                if (_flgGestioneEsito == undefined || _flgGestioneEsito == 0){
                    global.utils.alert.warning(data.messaggio);
                }
                else{
                    _handler(data);
                }
            }
        })
        .catch(err => {
            if (_showBar == true ){
                global.utils.unblockPage();
            }
            global.utils.alert.danger("Si è verificato un errore");
            console.error("Errore di rete" , err);   
            _handler({esito : -1, messaggio: "Errore di Rete", error: err})        
            
        });
        /*
        utils.ajax(_api, formData,function(data){

            if (_showBar == true ){
                global.utils.unblockPage();
            }    
            if (data.esito == 0){
                if (data['arrayCampi'] != undefined && data['compressed'] != undefined){
                    data.data = global.utils.getArrayFromJSON(data.arrayCampi,data.data);
                }
                _handler(data);
            }
            else{
                //SESSIONE UTENTE SCADUTA
                if (data.esito == 401){
                    if (global.utils.RELOAD_SESSIONE_SCADUTA == 1){
                        //global.utils.alert.standard("Sessione utente scaduta");
                        global.sprint._component.methods.startHandler();
                    }
                    else{
                        global.sprint._component.methods.startHandler();
                    }
                }
                //FORCE LOGOUT
                else if(data.esito == 999){
                    global.utils.blockPage();
                    setTimeout(() => {
                        global.utils.alert.standard(data.messaggio);
                    }, 500);
                    setTimeout(() => {
                        window.location.href = global.utils.BASE_API + "core/logout";
                    }, 3000);
                }
                if (_flgGestioneEsito == undefined || _flgGestioneEsito == 0){
                    global.utils.alert.warning(data.messaggio);
                }
                else{
                    _handler(data);
                }
            }
        }, _showBar, _flgGestioneEsito, _method);
        */
    /*
    },
    */

    downloadExcel: function(api, args, filename = "export.xlsx") {
        args.SESSION_TOKEN = global.utils.SESSION_TOKEN;
        const url = global.utils.BASE_API + api;
        
        fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(args)
          })
          .then(response => {
            if (!response.ok) {
              throw new Error('Errore nella risposta');
            }
            return response.blob();
          })
          .then(blob => {
            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = blobUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(blobUrl);
          })
          .catch(error => {
            console.error('Errore durante il download del file Excel:', error);
            global.utils.alert.danger("Errore nel download del file Excel.");
          });
    },

    esportaTabella: function(options) {
        // options = {
        //   tipo:          'tutti' | 'selezionati' | 'pagina'
        //   arrayCompleto: []              // array pieno del modulo
        //   arrayPagina:   []              // paginatedList.arr (pagina corrente)
        //   idField:       'ID_NOTA_SPESA' // campo PK
        //   modulo:        'noteSpese'     // chiave di dispatch backend
        //   formato:       1 | 2           // 1 = PDF, 2 = Excel (default 2)
        //   nomeFile:      'note_spese'    // nome base del file (senza estensione)
        // }
        var formato = options.formato || 2;

        var sourceArray;
        if (options.tipo == 'selezionati') {
            sourceArray = global.utils.array.select(options.arrayCompleto, 'SELEZIONATO', 1);
            if (sourceArray.length == 0) {
                global.utils.alert.warning('Nessun elemento selezionato.');
                return;
            }
        } else if (options.tipo == 'pagina') {
            sourceArray = options.arrayPagina;
        } else {
            sourceArray = options.arrayCompleto;
        }

        var ids = sourceArray.map(function(item) { return item[options.idField]; });

        // Mappa modulo → ID_REPORT (lato client, come fa 1005_BudgetProgetto.php)
        var moduliMap = { noteSpese: 2001, aziende: 2002, utenti: 2003, progetti: 2004, vociPreferite: 2005, primaNota: 2006, fatture: 2007, scadenzario: 2008, costi: 2009, incassi: 2010 };
        var idReport = moduliMap[options.modulo];
        if (!idReport) {
            global.utils.alert.warning('Modulo export non riconosciuto: ' + options.modulo);
            return;
        }

        // Apertura diretta via GET con IDS nella URL — nessuna sessione necessaria
        window.open(
            global.utils.BASE_API +
            'theb/report?ID_REPORT=' + idReport +
            '&FORMATO=' + formato +
            '&IDS=' + ids.join(',') +
            global.utils.getSessionToken()
        );
    },

    download : function(_api,_args,_handler,_showBar = true,_flgGestioneEsito = 0,_method = null){
        _method = (_method == undefined || _method == null) ? "POST" : _method;
        if (_showBar == true ){
            global.utils.blockPage();
        }
        _args.SESSION_TOKEN = global.utils.SESSION_TOKEN;
        //_args.FROM = 'deskalo';
        global.ajax({
			type: _method,
			data: _args,
			url: global.utils.BASE_API + _api,
			cache: false,
            //contentType: 'application/octet-stream',  
			//dataType: 'json',
			success: function (data) {
                _handler(data);
            },
            error: function( jqXHR,  textStatus, errorThrown ){
                global.utils.alert.danger("Si è verificato un errore");
                console.error(jqXHR,textStatus,errorThrown);
                if (jqXHR.status == 0){
                   // global.utils.stopSocket();
                }
                if (_showBar == true ){
                    global.utils.unblockPage();
                }
            }
		});
    },
    
    setCookie : function(cname, cvalue, exdays) {
        var expires = '';
        if (exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            expires = "expires=" + d.toUTCString() + ";";
        }
        document.cookie = cname + "=" + cvalue + ";" + expires + "path=/";
    },

    deleteCookie : function(cname){
        document.cookie = cname + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";
    },

    getCookie : function(cname) {
        //("cookie");
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },

    report : {
        token:function(args){
            global.utils.ajax('/core/report/basic/token',args, (response) => {
                if (response.esito == 0){
                    window.open(global.utils.BASE_API + '/core/report/basic?ID_REPORT=0&FORMATO='+args.formato+'&token='+response.messaggio );
                }
            });
        },
    },

    getArrayFromJSON : function(arrayCampi,arrayValori){
        var arrayDati = new Array();
        for (var i = 0 ; i<arrayValori.length ; i++){
            var item = new Object();
            for (var j = 0 ; j < arrayCampi.length ; j++){
                item[arrayCampi[j]] = arrayValori[i][j];
            }
            arrayDati.push(item);
        }
        return arrayDati;
    },

    diagnosi : function(item){
        //console.log(item);
    },

    setHeader : function(_icon,_title){
        if (typeof global.sprint !== "undefined"){
            global.sprint._component.icon = _icon;
            global.sprint._component.title = _title;            
        }
        else{
            setTimeout(() => {
                global.utils.setHeader(_icon,_title);
            }, 500);
        }
    },

    alert : {
        show:function(_tipo,messaggio,icona = "",titolo = "Attenzione",delay = 5000){
            new Notify({
                status: _tipo,
                title: titolo,
                text: messaggio,
                effect: 'slide',
                speed: 500,
                customClass: null,
                customIcon: null,
                showIcon: true,
                showCloseButton: true,
                autoclose: true,
                autotimeout: 3000,
                gap: 20,
                distance: 20,
                type: 'filled',
                position: 'right top'
              });
        },
        success:function(messaggio,titolo = "Attenzione", delay = 2500,icona = "",){
            global.utils.alert.show("success",messaggio,icona,titolo,delay);
        },
        warning:function(messaggio,titolo = "Attenzione", icona = "",delay = 5000){
            global.utils.alert.show("warning",messaggio,icona,titolo,delay);
        },
        info:function(messaggio,titolo = "Attenzione", icona = "",delay = 5000){
            global.utils.alert.show("info",messaggio,icona,titolo,delay);
        },
        danger:function(messaggio,titolo = "Attenzione", icona = "",delay = 5000){
            global.utils.alert.show("error",messaggio,icona,titolo,delay);
        },
        primary:function(messaggio,titolo = "Attenzione", icona = "",delay = 5000){
            global.utils.alert.show("alert",messaggio,icona,titolo,delay);
        },
        confirm:function(messaggio,okHandler,root,titolo = "Conferma scelta",koHandler = null,btnOk = "OK",btnKo = "Annulla",icona="fa-exclamation-triangle"){
            var alertConfirm = {
                MESSAGE : messaggio,
                TITLE : titolo,
                OKHandler : () => {
                    global.filters.closePopUp('popUpConfirm');
                    okHandler()
                },
                KOHandler : () => {
                    global.filters.closePopUp('popUpConfirm');
                    if(koHandler != null){
                        koHandler()
                    }
                },
                OK : btnOk,
                KO : btnKo,
                ICON : icona
            }
            //console.log(root);
            root.confirm(alertConfirm);
        },
        standard:function(messaggio,okHandler = null,titolo = "Attenzione",btnOk = "OK",icona="fal fa-info-circle"){
            global.sprint.alertStd = {
                MESSAGE : messaggio,
                TITLE : titolo,
                OKHandler : () => {
                    global.filters.closePopUp('popUpAlertStandard');
                    if (okHandler != null){
                        okHandler();
                    }
                },
                OK : btnOk,
                ICON : icona
            }
            global.filters.openPopUp('popUpAlertStandard');
        }
    },

    clone : function(obj){
        if (obj == undefined)
            return {};
        var s = JSON.stringify(obj);
        var newObj = JSON.parse(s);
        return newObj;
    },

    _loadingCount : 0,

    blockPage : function() {
        this._loadingCount++;
        var loading = document.getElementById('loading');
        if (loading != null)
            loading.classList.add('is-active');
    },

    unblockPage : function() {
        this._loadingCount = Math.max(0, this._loadingCount - 1);
        if (this._loadingCount == 0) {
            var loading = document.getElementById('loading');
            if (loading != null)
                loading.classList.remove('is-active');
        }
    },
    addClass : function(element,className){
        var element = document.getElementById(element);
        if (element != null)
            element.classList.add(className)
    },
    removeClass : function(element,className){
        var element = document.getElementById('loading');
        if (element != null)
            element.classList.remove(className);
    },

    pagination : {
        paginate:function(source,search){
            var page = parseInt(search.PAGINATION.PAGE_NUMBER) - 1;
            var itemsPerPage = parseInt(search.PAGINATION.PAGE_SIZE) || 25;
            var index = 0;
            var start = page * itemsPerPage;
            var end = start + itemsPerPage ;
            return source.filter( () => {
                if (index >= start && index < end){
                    index++;
                    return true;
                }
                index++;
                return false;
            })
        }
    },

    arrayGiorniSettimana : new Array(
        {ID_GIORNO:2,DESCRIZIONE:"LUNEDI",DESC_2:"LU",DESC_3:"LUN"},
        {ID_GIORNO:3,DESCRIZIONE:"MARTEDI",DESC_2:"MA",DESC_3:"MAR"},
        {ID_GIORNO:4,DESCRIZIONE:"MERCOLEDI",DESC_2:"ME",DESC_3:"MER"},
        {ID_GIORNO:5,DESCRIZIONE:"GIOVEDI",DESC_2:"GI",DESC_3:"GIO"},
        {ID_GIORNO:6,DESCRIZIONE:"VENERDI",DESC_2:"VE",DESC_3:"VEN"},
        {ID_GIORNO:7,DESCRIZIONE:"SABATO",DESC_2:"SA",DESC_3:"SAB"},
        {ID_GIORNO:1,DESCRIZIONE:"DOMENICA",DESC_2:"DO",DESC_3:"DOM"},
    ),

    getGiornoSettimana(idGiorno){
        return global.utils.array.select(global.utils.arrayGiorniSettimana,"ID_GIORNO",idGiorno,1)[0];
    },

    arrayMesi : new Array(
        {ID_MESE:1,DESCRIZIONE:"GENNAIO",DESC_3:"GEN"},
        {ID_MESE:2,DESCRIZIONE:"FEBBRAIO",DESC_3:"FEB"},
        {ID_MESE:3,DESCRIZIONE:"MARZO",DESC_3:"MAR"},
        {ID_MESE:4,DESCRIZIONE:"APRILE",DESC_3:"APR"},
        {ID_MESE:5,DESCRIZIONE:"MAGGIO",DESC_3:"MAG"},
        {ID_MESE:6,DESCRIZIONE:"GIUGNO",DESC_3:"GIU"},
        {ID_MESE:7,DESCRIZIONE:"LUGLIO",DESC_3:"LUG"},
        {ID_MESE:8,DESCRIZIONE:"AGOSTO",DESC_3:"AGO"},
        {ID_MESE:9,DESCRIZIONE:"SETTEMBRE",DESC_3:"SET"},
        {ID_MESE:10,DESCRIZIONE:"OTTOBRE",DESC_3:"OTT"},
        {ID_MESE:11,DESCRIZIONE:"NOVEMBRE",DESC_3:"NOV"},
        {ID_MESE:12,DESCRIZIONE:"DICEMBRE",DESC_3:"DIC"}
    ),

    arrayContinenti : new Array(
        {ID_CONTINENTE:1,DESCRIZIONE:"Asia"},
        {ID_CONTINENTE:2,DESCRIZIONE:"Messico e Caraibi"},
        {ID_CONTINENTE:3,DESCRIZIONE:"Europa"},
        {ID_CONTINENTE:4,DESCRIZIONE:"Africa"},
        {ID_CONTINENTE:5,DESCRIZIONE:"Oceano Indiano"},
        {ID_CONTINENTE:6,DESCRIZIONE:"Medio Oriente"},
        {ID_CONTINENTE:7,DESCRIZIONE:"Nord America"},
        {ID_CONTINENTE:8,DESCRIZIONE:"Pacifico"},
        {ID_CONTINENTE:9,DESCRIZIONE:"Sud America"},
        {ID_CONTINENTE:10,DESCRIZIONE:"Antartide"}
    ),

    getMese(idMese){
        return global.utils.array.select(global.utils.arrayMesi,"ID_MESE",idMese,1)[0];
    },

    getOrari(oraInizio,oraFine){
        var arrayOrari = new Array();
        for (var i = oraInizio ; i < oraFine ; i++){
            for (var j = 0 ; j < 60 ; j = j+5){
                var ora = i < 10 ? '0'+i : i;
                var minuto = j < 10 ? '0'+j : j;
                arrayOrari.push(ora+":"+minuto+":00");
            }
        }
        return arrayOrari;
    },

    getImportoScontato : function(importo,sconto){
        return Math.round((importo - (importo / 100 * sconto))*100) / 100;  
    },

    getSessionToken : function(){
        if (utils.BASE_API.search("localhost") > -1 || utils.BASE_API.search("192")){
            return "&SESSION_TOKEN="+utils.SESSION_TOKEN;
        }
        return "";
    },

    bonificaNumber : function(n){
        //console.log("bonifica");
        if (!isNaN(n)){
            return n;
        }
        else{
            s = n.toString();
            s = s.replace(".","");
            s = s.replace(",",".");
            if (!isNaN(s)){
                return parseFloat(s);
            }
            return NaN;
        }
    },

    formatNumber : function(num){   
        num = new Intl.NumberFormat('de-DE',{
            style:'decimal',
            minimumFractionDigits: 2
        }).format(num);
        return num;
    },

    formatNumberInt : function(num){
        num = new Intl.NumberFormat('de-DE',{
            style:'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(num);
        return num;
    },

    plurale : function(numero, singolare, plurale){
        return numero == 1 ? singolare : plurale;
    },

    getRandomInt : function(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    },

    getRandomString(length) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    },

    // LOADER
    createLoader : function(){
        //LOADER
        var t = document.createElement('div')
        t.innerHTML = `<div id="loading" class="loader loader-default">
            <div class="loader-default-sub"><div style="margin-top:32px;margin-left:80px;font-size:22px">Attendere prego</div></div>
        </div>`;
        document.body.appendChild(t);
    },

    getDateFromString : function(d){
        if (d == undefined || d == "" || d == null){
            return null;
        }
         //DATA INGLESE
        if (d.toString().indexOf("/") == -1){
            return new Date(d);
        }
        //DATA ITALIANA
        else{
            spl = d.toString().split("/");
            //VERIFICO LA PRESENZA DI UN TIME
            if (spl[2].toString().indexOf(" ") > -1){
                const anno = spl[2].toString().substring(0,4);
                const orario = spl[2].toString().substring(4);
                var s = anno + "/" + spl[1] + "/" + spl[0] + orario.substring(2);
                var d = new Date(s);
                return d;
            }
            var s = spl[2] +"/"+ spl[1] +"/"+ spl[0];
            return new Date(s);
        }
    },

    filter : function(source,search){
        var keys = Object.getOwnPropertyNames(search);
        var arr = source.filter(item => {
            for (var i = 0 ; i < keys.length ; i++){
                var prop = keys[i];
                if (item[prop] == undefined && search[prop]['TYPE'] != 'COMBO_IN_ARRAY' && search[prop]['TYPE'] != 'TEXT_IN_ARRAY'){
                    esito = true;
                    continue;
                }
                if (prop != "PAGINATION"){
                    var esito = true;
                    switch (search[prop]['TYPE']){
                        case 'TEXT':
                            esito = item[prop].toString().toLowerCase().includes(search[prop].VALUE.toLowerCase());
                            break;
                        case 'INT_RANGE':
                            if (search[prop].VALUE_FROM == "" && search[prop].VALUE_TO == ""){
                                esito = true;
                                break;
                            }
                            if (item[prop] >= search[prop].VALUE_FROM && (item[prop] <= search[prop].VALUE_TO || search[prop].VALUE_TO == "")){
                                esito = true;
                                break;
                            }
                            if (item[prop] <= search[prop].VALUE_TO && (item[prop] >= search[prop].VALUE_FROM || search[prop].VALUE_FROM == "")){
                                esito = true;
                                break;
                            }
                            esito = false;
                            break;
                        case 'COMBO':
                            if (search[prop].VALUE == "" || search[prop].VALUE == null){
                                esito = true;
                                break;
                            }
                            if (search[prop].VALUE.toString().search(",") != -1){
                                arr = search[prop].VALUE.split(",");
                                esito = arr.indexOf(item[prop]) > -1 ? true : false;
                                break;
                            }
                            else{
                                esito = item[prop] == search[prop].VALUE;
                                break;                                
                            }
                        case 'COMBO_IN_ARRAY':
                            if (search[prop].VALUE === ""){
                                esito = true;
                                break;
                            }
                            var proprietaArray = 'ARRAY';
                            if (search[prop].hasOwnProperty("CUSTOM_ARRAY")){
                                proprietaArray = 'CUSTOM_ARRAY';
                            }
                            esito = global.utils.array.select(item[search[prop][proprietaArray]],prop,search[prop].VALUE,1).length == 1 ? true : false;
                            break;
                        case 'TEXT_IN_ARRAY':
                            if (search[prop].VALUE === ""){
                                esito = true;
                                break;
                            }
                            var proprietaArray = 'ARRAY';
                            if (search[prop].hasOwnProperty("CUSTOM_ARRAY")){
                                proprietaArray = 'CUSTOM_ARRAY';
                            }
                            esito = false;
                            for (var k = 0 ; k < item[search[prop][proprietaArray]].length ; k++) {
                                const check = item[search[prop][proprietaArray]][k][prop].toString().toLowerCase().includes(search[prop].VALUE.toLowerCase());
                                if (check == true){
                                    esito = true;
                                    break;
                                }
                            }
                            break;

                        case 'DATE':
                            if (search[prop].VALUE == ""){
                                esito = true;
                                break;
                            }
                            var dProp = global.utils.getDateFromString(item[prop]);
                            if (dProp == null){
                                esito = false;
                                break;
                            }
                            var dataFiltro = global.utils.getDateFromString(search[prop].VALUE);
                            esito = dProp.getTime() == dataFiltro.getTime();
                            break;

                        case 'DATE_TIME':
                            if (search[prop].VALUE == "" || search[prop].VALUE == null){
                                esito = true;
                                break;
                            }
                            esito = item[prop].toString().includes(search[prop].VALUE);
                            break;

                        case 'DATE_RANGE':
                            var dPropr =  global.utils.getDateFromString(item[prop]  );
                            if (dPropr == null){
                                esito = true;
                                break;
                            }
                            var dataFiltroFrom = global.utils.getDateFromString(search[prop].VALUE_FROM );
                            var dataFiltroTo = global.utils.getDateFromString(search[prop].VALUE_TO );
                            if (dataFiltroFrom == null && dataFiltroTo == null){
                                esito = true;
                                break;
                            }
                            else if (dataFiltroFrom != null && dataFiltroTo != null){
                                esito = (dPropr.getTime() >= dataFiltroFrom.getTime() && dPropr.getTime() <= dataFiltroTo.getTime());
                                break;
                            }
                            else if (dataFiltroFrom != null && dataFiltroTo == null){
                                esito = (dPropr.getTime() >= dataFiltroFrom.getTime());
                            }
                            else{
                                esito = (dPropr.getTime() <= dataFiltroTo.getTime());
                            }
                            break;
                    }
                    if (esito == false){
                        //console.log(search[prop]);
                        return false;
                    }
                }
            }
            return true;
        })
        search.PAGINATION.LENGTH = Math.ceil(arr.length/search.PAGINATION.PAGE_SIZE);
        if (search.PAGINATION.LENGTH < search.PAGINATION.PAGE_NUMBER){
            search.PAGINATION.PAGE_NUMBER = 1;
        }
        return arr;
    },

    initTooltips: function (selector = '[data-bs-toggle="tooltip"]') {
        var tooltipTriggerList = [].slice.call(document.querySelectorAll(selector));
        tooltipTriggerList.forEach(function (tooltipTriggerEl) {
            if (!bootstrap.Tooltip.getInstance(tooltipTriggerEl)) {
                new bootstrap.Tooltip(tooltipTriggerEl);
                tooltipTriggerEl.addEventListener('click', function (event) {
                    event.preventDefault();
                    var tooltipInstance = bootstrap.Tooltip.getInstance(tooltipTriggerEl);
                    if (tooltipInstance) {
                        tooltipInstance.dispose();
                    }
                    tooltipTriggerEl.blur();
                });
            }
        });
    },

    inGrid : function(_array,_search, ordinamento = null){
        // **<<< INIZIO CORREZIONE >>>**
        // Controllo se _array è nullo, undefined o non è un array.
        // In caso negativo, restituisco immediatamente un risultato vuoto.
        if (!_array || !Array.isArray(_array)) {
            return {
                arr: [],
                count: 0
            };
        }
        // **<<< FINE CORREZIONE >>>**
        var filtrato = global.utils.filter(_array,_search);
        if (ordinamento != null){
            if (!(ordinamento.indexOf(",") > -1)){
                filtrato = global.utils.array.ordinaArray(filtrato,ordinamento.substring(1));
                if (ordinamento.charAt(0) == "-"){
                    filtrato = filtrato.reverse();
                }
            }
            else{
                var arr = ordinamento.split(",");
                var item = {};
                for (var i = 0 ; i < arr.length ; i++){
                    var senso = (arr[i].charAt(0) == "-") ? "desc" : "asc";
                    var prop = arr[i].substring(1);
                    item[prop] = senso;
                }
                filtrato = global.utils.array.multiSort(filtrato, item);
            }
        }
        setTimeout(() => {
            global.utils.initTooltips();
        }, 500);
        return {
            arr: global.utils.pagination.paginate(filtrato ,_search),
            count: filtrato.length
        }
    },

    inGridNested: function (_array, _search, ordinamento = null, nestedKey = null){
        var filtrato = [];
        if (_search && nestedKey) {
            const searchValue = (_search.USERNAME?.VALUE || "").toLowerCase();
            for (var i = 0; i < _array.length; i++) {
                var item = _array[i];
                if (item[nestedKey] && Array.isArray(item[nestedKey])) {
                    for (var j = 0; j < item[nestedKey].length; j++) {
                        var subItem = item[nestedKey][j];
    
                        for (var key in subItem) {
                            if (String(subItem[key]).toLowerCase().indexOf(searchValue) !== -1) {
                                filtrato.push(item);
                                break;
                            }
                        }
                        if (filtrato.includes(item)) {
                            break;
                        }
                    }
                }
            }
        } else if (_search) {
            const searchValue = (_search.USERNAME?.VALUE || "").toLowerCase();
    
            for (var i = 0; i < _array.length; i++) {
                var item = _array[i];
    
                for (var key in item) {
                    if (String(item[key]).toLowerCase().indexOf(searchValue) !== -1) {
                        filtrato.push(item);
                        break;
                    }
                }
            }
        } else {
            filtrato = _array;
        }
        if (ordinamento != null) {
            if (!(ordinamento.indexOf(",") > -1)) {
                filtrato = global.utils.array.ordinaArray(filtrato, ordinamento.substring(1));
                if (ordinamento.charAt(0) == "-") {
                    filtrato = filtrato.reverse();
                }
            } else {
                var arr = ordinamento.split(",");
                var item = {};
                for (var i = 0; i < arr.length; i++) {
                    var senso = (arr[i].charAt(0) == "-") ? "desc" : "asc";
                    var prop = arr[i].substring(1);
                    item[prop] = senso;
                }
                filtrato = global.utils.array.multiSort(filtrato, item);
            }
        }
        _search.PAGINATION.LENGTH = Math.ceil(filtrato.length / _search.PAGINATION.PAGE_SIZE);
        if (_search.PAGINATION.LENGTH < _search.PAGINATION.PAGE_NUMBER) {
            _search.PAGINATION.PAGE_NUMBER = 1;
        }
        return {
            arr: global.utils.pagination.paginate(filtrato, _search),
            count: filtrato.length
        };
    },

    inGridRecursive: function(_array, _search, ordinamento = null) {
        function filterRecursive(items) {
            return items.reduce((filtered, item) => {
                let itemMatches = true;
                let newItem = {...item};
                for (let key in _search) {
                    if (key !== 'PAGINATION' && _search[key].VALUE !== '') {
                        if (item[key] !== undefined) {
                            let searchValue = String(_search[key].VALUE).toLowerCase();
                            let itemValue = String(item[key]).toLowerCase();
                            
                            if (!itemValue.includes(searchValue)) {
                                itemMatches = false;
                            }
                        }
                    }
                }
                if (item.children && item.children.length > 0) {
                    newItem.children = filterRecursive(item.children);
                    if (newItem.children.length > 0) {
                        itemMatches = true;
                    }
                }
                
                if (itemMatches) {
                    filtered.push(newItem);
                }
                return filtered;
            }, []);
        }
        
        let filtrato = filterRecursive(_array);
        if (ordinamento != null) {
            if (!(ordinamento.indexOf(",") > -1)) {
                filtrato = global.utils.array.ordinaArray(filtrato, ordinamento.substring(1));
                if (ordinamento.charAt(0) == "-") {
                    filtrato = filtrato.reverse();
                }
            } else {
                let arr = ordinamento.split(",");
                let item = {};
                for (let i = 0; i < arr.length; i++) {
                    let senso = (arr[i].charAt(0) == "-") ? "desc" : "asc";
                    let prop = arr[i].substring(1);
                    item[prop] = senso;
                }
                filtrato = global.utils.array.multiSort(filtrato, item);
            }
        }
        
        return {
            arr: global.utils.pagination.paginate(filtrato, _search),
            count: filtrato.length
        };
    },

    inGridRicorsiva: function(_array, _search, ordinamento, voceKey) {
        voceKey = voceKey || 'VOCI';
        var keys = Object.getOwnPropertyNames(_search);
        var activeFilters = [];
        for (var k = 0; k < keys.length; k++) {
            if (keys[k] !== 'PAGINATION' && _search[keys[k]].VALUE !== '') {
                activeFilters.push(keys[k]);
            }
        }

        function matchField(item, prop) {
            if (item[prop] === undefined || item[prop] === null) return null;
            var val = item[prop].toString();
            var searchVal = _search[prop].VALUE.toString();
            switch (_search[prop].TYPE) {
                case 'TEXT': return val.toLowerCase().indexOf(searchVal.toLowerCase()) >= 0;
                case 'COMBO': return val === searchVal;
                case 'NUMBER': return item[prop] == _search[prop].VALUE;
                case 'DATE': return item[prop] == _search[prop].VALUE;
                default: return null;
            }
        }

        function filterNode(node) {
            var voceFilters = [];
            for (var i = 0; i < activeFilters.length; i++) {
                var prop = activeFilters[i];
                var res = matchField(node, prop);
                if (res === null) {
                    voceFilters.push(prop);
                } else if (!res) {
                    return null;
                }
            }

            var copy = Object.assign({}, node);

            var filteredSub = [];
            if (node.SOTTO_ATTIVITA && node.SOTTO_ATTIVITA.length > 0) {
                for (var s = 0; s < node.SOTTO_ATTIVITA.length; s++) {
                    var sub = filterNode(node.SOTTO_ATTIVITA[s]);
                    if (sub !== null) filteredSub.push(sub);
                }
                copy.SOTTO_ATTIVITA = filteredSub;
            }

            if (voceFilters.length > 0) {
                var voci = node[voceKey] || [];
                var filteredVoci = voci.filter(function(voce) {
                    for (var i = 0; i < voceFilters.length; i++) {
                        var r = matchField(voce, voceFilters[i]);
                        if (r !== null && !r) return false;
                    }
                    return true;
                });
                copy[voceKey] = filteredVoci;
                if (filteredVoci.length === 0 && filteredSub.length === 0) return null;
            }

            return copy;
        }

        var filtrato = [];
        for (var i = 0; i < _array.length; i++) {
            var result = filterNode(_array[i]);
            if (result !== null) filtrato.push(result);
        }

        if (ordinamento) {
            if (ordinamento.indexOf(',') < 0) {
                filtrato = global.utils.array.ordinaArray(filtrato, ordinamento.substring(1));
                if (ordinamento.charAt(0) === '-') filtrato = filtrato.reverse();
            } else {
                var arr = ordinamento.split(',');
                var sortObj = {};
                for (var i = 0; i < arr.length; i++) {
                    sortObj[arr[i].substring(1)] = (arr[i].charAt(0) === '-') ? 'desc' : 'asc';
                }
                filtrato = global.utils.array.multiSort(filtrato, sortObj);
            }
        }

        _search.PAGINATION.LENGTH = Math.ceil(filtrato.length / _search.PAGINATION.PAGE_SIZE);
        if (_search.PAGINATION.LENGTH < _search.PAGINATION.PAGE_NUMBER) {
            _search.PAGINATION.PAGE_NUMBER = 1;
        }

        return {
            arr: global.utils.pagination.paginate(filtrato, _search),
            count: filtrato.length
        };
    },

    
    inGrid2Levels: function(_array, _search, ordinamento = null, nestedKey = null){
        var filtrato = [];
        var keys = Object.getOwnPropertyNames(_search);

        var activeFilters = [];
        for (var k = 0; k < keys.length; k++){
            var prop = keys[k];
            if (prop != "PAGINATION" && _search[prop].VALUE != ""){
                activeFilters.push(prop);
            }
        }
        if (activeFilters.length == 0){
            filtrato = _array;
        }
        else{
            for (var i = 0; i < _array.length; i++){
                var item = _array[i];
                var itemMatchCount = 0;
                var itemFilterCount = 0;
                var vociFiltered = [];

                for (var k = 0; k < activeFilters.length; k++){
                    var prop = activeFilters[k];

                    if (item[prop] != undefined){
                        itemFilterCount++;
                        var esito = true;
                        switch (_search[prop]['TYPE']){
                            case 'TEXT':
                                esito = item[prop].toString().toLowerCase().includes(_search[prop].VALUE.toLowerCase());
                                break;
                            case 'COMBO':
                                esito = (item[prop].toString() == _search[prop].VALUE);
                                break;
                            case 'NUMBER':
                                esito = (item[prop] == _search[prop].VALUE);
                                break;
                            case 'DATE':
                                esito = (item[prop] == _search[prop].VALUE);
                                break;
                        }
                        if (esito){
                            itemMatchCount++;
                        }
                    }
                }

                if (nestedKey && item[nestedKey] && Array.isArray(item[nestedKey])){
                    for (var j = 0; j < item[nestedKey].length; j++){
                        var child = item[nestedKey][j];
                        var childMatchCount = 0;
                        var childFilterCount = 0;

                        for (var k = 0; k < activeFilters.length; k++){
                            var prop = activeFilters[k];

                            if (child[prop] != undefined){
                                childFilterCount++;
                                var esito = true;
                                switch (_search[prop]['TYPE']){
                                    case 'TEXT':
                                        esito = child[prop].toString().toLowerCase().includes(_search[prop].VALUE.toLowerCase());
                                        break;
                                    case 'COMBO':
                                        esito = (child[prop].toString() == _search[prop].VALUE.toString());
                                        break;
                                    case 'NUMBER':
                                        esito = (child[prop] == _search[prop].VALUE);
                                        break;
                                    case 'DATE':
                                        esito = (child[prop] == _search[prop].VALUE);
                                        break;
                                }
                                if (esito){
                                    childMatchCount++;
                                }
                            }
                        }


                        if (childFilterCount == 0 || childMatchCount == childFilterCount){
                            vociFiltered.push(child);
                        }
                    }
                }


                var itemMatchesAll = (itemFilterCount == 0 || itemMatchCount == itemFilterCount);

                if (itemMatchesAll){

                    var itemClone = Object.assign({}, item);
                    itemClone[nestedKey] = vociFiltered;
                    filtrato.push(itemClone);
                }

                else if (itemMatchesAll && itemFilterCount > 0 && (!nestedKey || !item[nestedKey])){
                    filtrato.push(item);
                }
            }
        }

        if (ordinamento != null){
            if (!(ordinamento.indexOf(",") > -1)){
                filtrato = global.utils.array.ordinaArray(filtrato,ordinamento.substring(1));
                if (ordinamento.charAt(0) == "-"){
                    filtrato = filtrato.reverse();
                }
            }
            else{
                var arr = ordinamento.split(",");
                var item = {};
                for (var i = 0 ; i < arr.length ; i++){
                    var senso = (arr[i].charAt(0) == "-") ? "desc" : "asc";
                    var prop = arr[i].substring(1);
                    item[prop] = senso;
                }
                filtrato = global.utils.array.multiSort(filtrato, item);
            }
        }

        setTimeout(() => {
            global.utils.initTooltips();
        }, 500);

        return {
            arr: global.utils.pagination.paginate(filtrato, _search),
            count: filtrato.length
        }
    },

    openFileOnChrome(allegato) {
        if (!allegato || !allegato.contenuto) {
            console.error("Nessun file disponibile");
            return;
        }
        // Decodifica il contenuto in Base64
        const byteCharacters = atob(allegato.contenuto);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);

        // Determina il tipo di file in base all'estensione
        const fileExtension = allegato.nome.split('.').pop().toLowerCase();
        let mimeType = "application/octet-stream"; // Default

        if (["pdf"].includes(fileExtension)) {
            mimeType = "application/pdf";
        } else if (["jpg", "jpeg", "png", "gif", "webp"].includes(fileExtension)) {
            mimeType = "image/" + fileExtension;
        } else if (["doc", "docx"].includes(fileExtension)) {
            mimeType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        } else if (["xls", "xlsx"].includes(fileExtension)) {
            mimeType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        } else if (["txt"].includes(fileExtension)) {
            mimeType = "text/plain";
        }

        // Crea il file Blob e l'URL per aprirlo
        const blob = new Blob([byteArray], { type: mimeType });
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
    },

    arrayForCombo : function(array,campo_id,campo_descrizione){
        var arr = new Array();
        for (var i = 0 ; i < array.length ; i++){
            var item = {ID:parseInt(array[i][campo_id]),DESCRIZIONE:array[i][campo_descrizione]};
            arr.push(item);
        }
        return arr;
    },

    resizeContent : function(){
        return;
    },

    nuovoElemento : function(_element,_object,_popup){
        _element = _object;
        global.filters.openPopUp(_popup);
        return _element;
    },

    modificaElemento : function(_element,_object,_popup){
        _element = global.utils.clone(_object);
        global.filters.openPopUp(_popup);
        return _element;
    },

    salvaElemento : function(api,_object,_chiave,_popup,_handler = null){
        var method = _object[_chiave] == 0 ? 'insert' : 'update';
        var _fn = method == 'insert' ? global.utils.post : global.utils.put;
        _fn(api + method,_object, (response) => {
            if (_handler != null){
                _handler(response);
            }
            else{
                if (response.esito == 0){
                    global.filters.closePopUp(_popup);
                    global.utils.alert.success(response.messaggio);
                }
            }
        }); 
    },	

    //frazioni:1,2,3,4,6,12
    generaArrayTime : function(oraInizio,oraFine,frazioni){
        var arr = new Array();
        for (var i = oraInizio ; i < oraFine ; i++){
            for (var j = 0 ; j < frazioni ; j++){
                var f = j * (60/frazioni);
                var ora = i < 10 ? "0"+i : i;
                var minuti = f < 10 ? "0"+f : f;
                arr.push(ora+":"+minuti);
            }
        }
        return arr;
    },

    downloadFile: function(api, args, filename = "download", onComplete = null) {
        args.SESSION_TOKEN = global.utils.SESSION_TOKEN;
        const url = global.utils.BASE_API + api;
        if (typeof global.filters?.openPopUp === 'function') {
            global.filters.openPopUp('modalLoading');
        }
        fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(args)
        })
        .then(response => {
            if (!response.ok) throw new Error('Errore nella risposta');
            return response.blob();
        })
        .then(blob => {
            const contentType = blob.type;
            const extension = contentType.includes('zip') ? '.zip'
                : contentType.includes('excel') ? '.xlsx'
                : contentType.includes('pdf') ? '.pdf'
                : '';

            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = blobUrl;
            a.download = filename + extension;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(blobUrl);
        })
        .catch(err => {
            console.error("Errore nel download:", err);
            global.utils.alert.danger("Errore nel download.");
        })
        .finally(() => {
            if (typeof global.filters?.closePopUp === 'function') {
                global.filters.closePopUp('modalLoading');
            }
            if (typeof onComplete === 'function') onComplete();
        });
    },

    generateRandomString(length){
        let result = "", seeds
    
        for(let i = 0; i < length - 1; i++){
            //Generate seeds array, that will be the bag from where randomly select generated char
            seeds = [
                Math.floor(Math.random() * 10) + 48,
                Math.floor(Math.random() * 25) + 65,
                Math.floor(Math.random() * 25) + 97
            ]
            
            //Choise randomly from seeds, convert to char and append to result
            result += String.fromCharCode(seeds[Math.floor(Math.random() * 3)])
        }
    
        return result
    },

    getContrastColor(hexColor) {
        if (!hexColor) return null;
        let hex = hexColor.replace('#', '');
        if (hex.length == 3) hex = hex.split('').map(c => c + c).join('');
        const r = parseInt(hex.substr(0, 2), 16);
        const g = parseInt(hex.substr(2, 2), 16);
        const b = parseInt(hex.substr(4, 2), 16);
        const yiq = (r * 299 + g * 587 + b * 114) / 1000;
        return yiq >= 128 ? '#000000' : '#ffffff';
    },

    navIsOpen : false,

    /* Set the width of the side navigation to 250px */
    openNav() {
        return;
    },

    /* Set the width of the side navigation to 0 */
    closeNav() {
        return;
    },

    wait : (_handler,time = 300) => {
        setTimeout(() => {
            _handler();          
        }, time);
    }, 
    
    valutaRecapito(destinatario,tipo,flgServer){
        var recapito = destinatario.TELEFONO;
        var recapito2 = destinatario.RECAPITO_2;
        var recapito3 = destinatario.RECAPITO_3;
        var DESTINAZIONE = "";
        var email = destinatario.EMAIL;
        var stato = 0;
        var errore = "";
        //SMS
        if (tipo == 1){
            if (flgServer == 0){
                recapito = destinatario.DESTINAZIONE;
            }
            if (recapito != null && recapito.length > 0){
                recapito = recapito.replace(" ","");
                recapito = recapito.replace("-","");
                recapito = recapito.replace("/","");
                if ( (recapito2 != null && recapito2.length > 0) || (recapito3 != null && recapito3.length > 0)){
                    stato = 1;
                    errore = "Più numeri di telefono in anagrafica";
                }
                else if (recapito.length > 10){
                    stato = 1;
                    errore = "Il formato del campo RECAPITO 1 potrebbe essere errato";
                }
                else if (recapito.charAt(0) == '0'){
                    stato = 1;
                    errore = "Il numero impostato potrebbe essere un numero fisso";
                }
                DESTINAZIONE = recapito;
            }
            else{
                if ( (recapito2 != null && recapito2.length > 0) || (recapito3 != null && recapito3.length > 0)){
                    if ((recapito2 != null && recapito2.length > 0) && (recapito3 != null && recapito3.length > 0)){
                        stato = 1;
                        errore = "Più numeri di telefono in anagrafica";
                    }
                    else{
                        if (recapito2 != null && recapito2.length > 0){
                            if (recapito2.length > 10){
                                stato = 1;
                                errore = "Il formato del campo RECAPITO 2 potrebbe essere errato";
                            }
                            else{
                                DESTINAZIONE = recapito2;
                            }
                        }
                        else if (recapito3 != null && recapito3.length > 0){
                            if (recapito3.length > 10){
                                stato = 1;
                                errore = "Il formato del campo RECAPITO 3 potrebbe essere errato";
                            }
                            else{
                                DESTINAZIONE = recapito3;
                            }
                        }
                    }
                }
                else{
                    stato = 1;
                    errore = "RECAPITO 1 non presente";
                }
            }				
        }
        else{
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (flgServer == 0){
                email = destinatario.DESTINAZIONE;
            }
            if (email == null || email.length == 0){
                stato = 1;
                errore = "Email non definita";
            }
            else{
                if (re.test(email) == false){
                    stato = 1;
                    errore = "Formato email non corretto";
                }
                DESTINAZIONE = email;
                                
            }
        }
        return {STATO:stato,ERRORE:errore,DESTINAZIONE:DESTINAZIONE};
    },

    array : {
        // Dopo un salvataggio: la riga salvata prende i dati del server, le altre restano come sono a video
        mantieniRighe : function (nuove, vecchie, chiave, salvata = null) {
            const altre = (vecchie || []).filter(r => r != salvata);
            return [
                ...(nuove || []).map(n => altre.find(r => r[chiave] != 0 && r[chiave] == n[chiave]) || n),
                ...altre.filter(r => r[chiave] == 0)
            ];
        },

        getMax : function (_array, nomeCampo) {
            var max = 0;
            for (var i = 0 ; i < _array.length ; i++) {
                if (nomeCampo == undefined) {
                    if (_array[i] > max) {
                        max = _array[i];
                    }
                }
                else {
                    if (_array[i][nomeCampo] > max) {
                        max = _array[i][nomeCampo];
                    }
                }
            }
            return max;
        },


        getMin : function (_array, nomeCampo) {
            var min = 9007199254740992;
            for (var i = 0 ; i < _array.length ; i++) {
                if (nomeCampo == undefined) {
                    if (_array[i] < min) {
                        min = _array[i];
                    }
                }
                else {
                    if (_array[i][nomeCampo] < min) {
                        min = _array[i][nomeCampo];
                    }
                }
            }
            return min;
        },


        selectByModuloIcona : function (_arrayCategorie, _arrayTipoModuli, _arrayIdModuliAmmessi) {
            return _arrayCategorie.filter(function (cat) {
                var modulo = global.utils.array.select(_arrayTipoModuli, 'ICONA', cat.FK_ID_MODULO, 1)[0];
                return modulo != undefined && _arrayIdModuliAmmessi.indexOf(modulo.ID_OPZIONE_TIPOLOGICA) != -1;
            });
        },


        sumByField : function (_array, nomeCampo) {
            var somma = 0;
            for (var i = 0 ; i < _array.length ; i++) {
                if (nomeCampo == undefined) {
                    somma += parseFloat(_array[i]);
                }
                else {
                    somma += parseFloat(_array[i][nomeCampo]);
                }
            }
            return somma;
        },

        sumByFieldSigned : function (_array, nomeCampo, signField) {
            var somma = 0;
            for (var i = 0; i < _array.length; i++) {
                var v = parseFloat(_array[i][nomeCampo] || 0);
                somma += (_array[i][signField] === 0 ? -v : v);
            }
            return somma;
        },

        raggruppaArray : function (arrayColl,
            groupField,
            descrizioneField,
            nomeCampoDescrizionePadre,
            nomeCampoArrayFigli,
            flgNumerico,
            flgDesc){

                if (flgNumerico == undefined){
                    flgNumerico = false;
                }
                if (flgDesc == undefined){
                    flgDesc = false;
                }
                var arrayGrouped = new Array();
                arrayColl = global.utils.array.ordinaArray(arrayColl, groupField);
                var arrayColl2 = new Array();
                for (var z = 0 ; z < arrayColl.length ; z++) {
                    arrayColl2.push(arrayColl[z]);
                }
                var valGroupField = '';

                for (var i = arrayColl2.length -1 ; i> -1 ; --i){
                    var item = arrayColl2[i];
                    if (item[groupField] != valGroupField){
                        valGroupField = item[groupField];
                        var padre = new Object();
                        padre[nomeCampoDescrizionePadre] = item[groupField];
                        padre[nomeCampoArrayFigli] = new Array();
                        arrayGrouped.push(padre);
                        arrayColl2.splice(i,1);
                    }
                    else{
                        arrayColl2.splice(i,1);
                    }
                    item = null;
                }
                for (let i = 0 ; i<arrayGrouped.length ; i++){
                    let padre = arrayGrouped[i];
                    for (var k = arrayColl.length - 1 ; k>-1 ; --k){
                        if (arrayColl[k][groupField] == padre[nomeCampoDescrizionePadre]){
                            padre[nomeCampoArrayFigli].push(arrayColl[k]);
                            arrayColl.splice(k,1);
                            if (k == -1){
                                break;
                            }
                        }
                        else{
                            break;
                        }
                    }
                }
                return arrayGrouped;
        },

        ordinaArray : function(array, key){
            return array.sort(function(a, b) {
                var x = a[key];
                var y = b[key];
                if (typeof x === "string")
                {
                    try{
                        x = x.toLowerCase();
                        y = y.toLowerCase();
                    }
                    catch (e){
                    }
                    
                }

                return ((x < y) ? -1 : ((x > y) ? 1 : 0));
            });
        },

        /**
         * Sorts an array of objects by column/property.
         * @param {Array} array - The array of objects.
         * @param {object} sortObject - The object that contains the sort order keys with directions (asc/desc). e.g. { age: 'desc', name: 'asc' }
         * @returns {Array} The sorted array.
         * 
         * 
         * //console.log('sorted by Age (desc), Name (asc), Years (desc):', multiSort(data, {
                age: 'desc',
                name: 'asc',
                years: 'desc'
            }));
         */
        multiSort : function(array, sortObject = {}) {
            const sortKeys = Object.keys(sortObject);

            // Return array if no sort object is supplied.
            if (!sortKeys.length) {
                return array;
            }

            // Change the values of the sortObject keys to -1, 0, or 1.
            for (let key in sortObject) {
                sortObject[key] = sortObject[key] === 'desc' || sortObject[key] === -1 ? -1 : (sortObject[key] === 'skip' || sortObject[key] === 0 ? 0 : 1);
            }

            const keySort = (a, b, direction) => {
                direction = direction !== null ? direction : 1;

                if (a === b) { // If the values are the same, do not switch positions.
                    return 0;
                }

                // If b > a, multiply by -1 to get the reverse direction.
                return a > b ? direction : -1 * direction;
            };

            return array.sort((a, b) => {
                let sorted = 0;
                let index = 0;

                // Loop until sorted (-1 or 1) or until the sort keys have been processed.
                while (sorted === 0 && index < sortKeys.length) {
                    const key = sortKeys[index];

                    if (key) {
                        const direction = sortObject[key];

                        sorted = keySort(a[key], b[key], direction);
                        index++;
                    }
                }

                return sorted;
            });
        },

        distinct : function (_array,  _id, _desc) {
            var arrayNew = new Array();
            for (var i = 0 ; i < _array.length ; i++) {
                var controllo = false;
                for (var j = 0 ; j < arrayNew.length ; j++) {
                    if (_array[i][_id] == arrayNew[j][_id]) {
                        controllo = true;
                        break;
                    }
                }
                if (controllo == false) {
                    var item = new Object();
                    item[_id] = _array[i][_id];
                    if (_array[i][_desc] != undefined) {
                        item[_desc] = _array[i][_desc];
                    }
                    arrayNew.push(item);
                }
            }
            return arrayNew;
        },


        select : function (_array, _key, _val, _count) {
            var arrayNew = new Array();
            for (var i = 0 ; i < _array.length ; i++) {
                if (_array[i][_key] == _val) {
                    arrayNew.push(_array[i]);
                }
                if (_count != undefined && arrayNew.length == _count) {
                    return arrayNew;
                }
            }
            return arrayNew;
        },

        getItemIndex : function (_array, _key, _val) {
            for (var i = 0 ; i < _array.length ; i++) {
                if (_array[i][_key] == _val) {
                    return i;
                }                
            }
            return -1;
        },


        selectEval : function (_array, condition, _count) {
            var arrayNew = new Array();
            for (var i = 0 ; i < _array.length ; i++) {
                var item = _array[i]
                if (eval(condition) == true) {
                    arrayNew.push(item);
                }
                if (_count != undefined && arrayNew.length == _count) {
                    return arrayNew;
                }
            }
            return arrayNew;
        },

        toSelect2 : function(_array,_id,_text){
            var arrayNew = new Array();
            for (var i = 0 ; i < _array.length ; i++) {
                var item = _array[i]
                arrayNew.push({
                    id:item[_id],text:item[_text]
                });
            }
            return arrayNew;
        },
        toId : function(_array,id){
            var arr = new Array();
            for (var i = 0 ; i < _array.length ; i++) {
                arr.push(_array[i][id]);
            }
            return arr;
        }
    },

    mergeObjects : function(objects,merge = null,overwrite = 1){
        if (merge == null){
            merge = {}
        }
        for (var k = 0 ; k < objects.length ; k++){
            var item = objects[k];
            if (item == undefined){
                continue;
            }
            var arr = Object.keys(item);
            for (var i = 0 ; i < arr.length ; i++){
                if (!merge.hasOwnProperty(arr[i]) || overwrite == 1){
                    merge[arr[i]] = item[arr[i]];                   
                }
            }
        }
        return merge;
    },
    google:{
        importaPlace(place,model){
            //route,street_number,administrative_area_level_2

            var componentForm = new Array({google:'route',travel:'INDIRIZZO',target:'long_name'},
                                            {google:'postal_code',travel:'CAP',target:'short_name'},
                                            {google:'street_number',travel:'CIVICO',target:'short_name'},
                                            {google:'administrative_area_level_2',travel:'PROV',target:'short_name'},
                                            {google:'locality',travel:'CITTA',target:'short_name'}
                                        );

            model.LATITUDINE = place.geometry.location.lat();
            model.LONGITUDINE = place.geometry.location.lng();
            for (var i = 0; i < place.address_components.length; i++) {
                var addressType = place.address_components[i].types[0];
                for (var j = 0 ; j < componentForm.length ; j++){
                    if (componentForm[j].google == addressType) {
                        var val = place.address_components[i][componentForm[j].target];
                        model[componentForm[j].travel] = val;
                        break;
                    }
                }
            }
            return model;
        }
    },

    // GESTIONE PERMESSI E FUNZIONALITA
    permissions: {
        /**
         * Verifica se l'utente loggato ha una specifica funzionalità
         * @param {string} azione - Il codice azione della funzionalità (es: 'PROGETTO_UPDATE', 'PROGETTO_DELETE')
         * @returns {boolean} true se l'utente ha il permesso, false altrimenti
         */
        hasFunzionalita(azione) {
            // root da filters (init in App.vue): sprint._instance è null nelle build di produzione
            const utente = global.filters && global.filters.root ? global.filters.root.utente : null;
            if (!utente || !utente.funzionalita || utente.funzionalita.length == 0) {
                return false;
            }
            return utente.funzionalita.some(f => f.AZIONE == azione);
        },

        /**
         * Verifica se l'utente loggato ha una specifica funzionalità tramite ID
         * @param {number} idFunzionalita - L'ID della funzionalità
         * @returns {boolean} true se l'utente ha il permesso, false altrimenti
         */
        hasFunzionalitaById(idFunzionalita) {
            const utente = global.filters && global.filters.root ? global.filters.root.utente : null;
            if (!utente || !utente.funzionalita || utente.funzionalita.length == 0) {
                return false;
            }
            return utente.funzionalita.some(f => f.ID_FUNZIONALITA == idFunzionalita);
        },

        /**
         * Verifica se l'utente loggato ha TUTTE le funzionalità specificate
         * @param {string[]} azioni - Array di codici azione
         * @returns {boolean} true se l'utente ha tutti i permessi, false altrimenti
         */
        hasAllFunzionalita(azioni) {
            return azioni.every(azione => this.hasFunzionalita(azione));
        },

        /**
         * Verifica se l'utente loggato ha ALMENO UNA delle funzionalità specificate
         * @param {string[]} azioni - Array di codici azione
         * @returns {boolean} true se l'utente ha almeno un permesso, false altrimenti
         */
        hasAnyFunzionalita(azioni) {
            return azioni.some(azione => this.hasFunzionalita(azione));
        },

        /**
         * Ottiene tutte le funzionalità dell'utente loggato
         * @returns {Array} Array di funzionalità
         */
        getFunzionalita() {
            const utente = global.filters && global.filters.root ? global.filters.root.utente : null;
            return (utente && utente.funzionalita) ? utente.funzionalita : [];
        },

        /**
         * Mostra un messaggio di errore se l'utente non ha il permesso
         * @param {string} messaggio - Messaggio personalizzato (opzionale)
         */
        showPermissionDenied(messaggio = "Non hai i permessi necessari per eseguire questa operazione") {
            global.utils.alert.warning(messaggio);
        },

        /**
         * Verifica il permesso e mostra un messaggio se non ce l'ha
         * @param {string} azione - Il codice azione della funzionalità
         * @param {string} messaggio - Messaggio personalizzato (opzionale)
         * @returns {boolean} true se ha il permesso, false altrimenti
         */
        checkAndNotify(azione, messaggio) {
            const hasPermission = this.hasFunzionalita(azione);
            if (!hasPermission) {
                this.showPermissionDenied(messaggio);
            }
            return hasPermission;
        }
    },

    notifiche: {
        invia: function(context, titolo, testo) {
            var modulo = context.filters.getModuloCorrente(context.$root.$route.path);
            if (!modulo || !modulo.ICONA) return;
            var idModuloOpzione = parseInt(modulo.ID_OPZIONE_TIPOLOGICA);
            var idModuloIcona   = parseInt(modulo.ICONA);
            var tipologia = (context.$root.arrayNotificheTipologie || []).find(function(t) {
                return t.AZIONE === titolo && parseInt(t.FK_ID_MODULO) === idModuloOpzione;
            });
            if (!tipologia) return;
            utils.ajax('shared/notifiche/insert', {
                DESCRIZIONE: testo,
                FK_ID_MODULO: idModuloIcona,
                FK_ID_ENTE: context.$root.idEnteCorrente,
                FK_ID_TIPOLOGIA: tipologia.ID_TIPOLOGIA_NOTIFICA,
                FK_ID_OPERAZIONE: 0,
                FK_ID_UTENTE: context.$root.utente.ID_UTENTE
            }, function(res) {
                if (res.esito == 0) {
                    context.$root.appoggio.socket.emit('moduleEvent', {
                        FK_ID_MODULO: idModuloOpzione,
                        FK_ID_TIPOLOGIA: tipologia.ID_TIPOLOGIA_NOTIFICA,
                        FK_ID_UTENTE: context.$root.utente.ID_UTENTE
                    });
                }
            }, false);
        }
    },

    // Solo god. azione: 'LOGOUT' (butta fuori l'utente) | 'RICARICA' (ricarica i permessi in sessione, senza logout)
    sessioneUtente: function(context, utente, azione) {
        utils.put('theb/utente/sessione', { ID_UTENTE: utente.ID_UTENTE, AZIONE: azione }, function(res) {
            if (res.esito == 0) {
                var socket = context.$root.appoggio.socket;
                if (socket) {
                    socket.emit('sessioneUtente', { userId: utente.ID_UTENTE, azione: azione });
                }
                utils.alert.success(azione == 'RICARICA' ? 'Permessi ricaricati per ' + utente.USERNAME : res.messaggio);
            }
        });
    }


};


//module.exports = utils;
exports.utils = utils;
